import { createRoot } from "react-dom/client";
import "./index.css";
import { LanguageProvider } from "./contexts/LanguageContext.tsx";
import { AiDietaryPreferencesProvider } from "./contexts/AiDietaryPreferencesContext.tsx";
import { CartProvider } from "./contexts/CartProvider.tsx";
import { BrowserRouter } from "react-router";
import App from "./App.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthProvider.tsx";
import { LocationProvider } from "./contexts/LocationProvider.tsx";
import { LocationModalProvider } from "./contexts/LocationModalProvider.tsx";
import { LoginModalProvider } from "./contexts/LoginModalProvider.tsx";
import "react-loading-skeleton/dist/skeleton.css";
import { ItemModalProvider } from "./contexts/ItemModalProvider.tsx";
import { SearchProvider } from "./contexts/SearchProvider.tsx";
import "./i18n";
import ScrollToTop from "./components/ScrollToTop.tsx";
import { FavouritesProvider } from "./contexts/FavouritesProvider.tsx";
import { UserDetailModalProvider } from "./contexts/UserDetailModalProvider.tsx";
import { AddressesProvider } from "./contexts/AddressesProvider.tsx";

const queryClient = new QueryClient();

console.log = () => {};

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <LocationProvider>
          <LocationModalProvider>
            <LoginModalProvider>
              <AddressesProvider>
                <LanguageProvider>
                  <AiDietaryPreferencesProvider>
                    <CartProvider>
                      <UserDetailModalProvider>
                        <FavouritesProvider>
                          <ScrollToTop />
                          <SearchProvider>
                            <ItemModalProvider>
                              <App />
                            </ItemModalProvider>
                          </SearchProvider>
                        </FavouritesProvider>
                      </UserDetailModalProvider>
                    </CartProvider>
                  </AiDietaryPreferencesProvider>
                </LanguageProvider>
              </AddressesProvider>
            </LoginModalProvider>
          </LocationModalProvider>
        </LocationProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);
